let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2Tyv2")).then(() => parcelRequire('2V7Za'));